<template>
  <div class="vz-switcher-accordion">
    <div v-for="item of items" :key="item.value" class="vz-switcher-accordion-wrapper">
      <div class="vz-switcher-accordion-item"
        :class="switcherItemClass(item)"
        @click="onChange(item, $event)"
      >
        <vz-icon
          v-if="item.icon"
          :url="item.icon.url"
          :size="item.icon.size"
          no-masked-icon
          class="mr-10 flex-align-self-start"
          :variant="item.value === modelValue ? 'primary': ''"
        />
        <span v-html="item.title" />
      </div>
      <transition name="fade">
        <div v-show="item.value === modelValue" class="vz-switcher-accordion-content">
          <slot />
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { SwitchItem, VzClass } from '~/types/types'

const emit = defineEmits([
  'change',
  'update:modelValue'
])
const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  items: {
    type: Array as PropType<SwitchItem[]>,
    default: () => []
  },
  disabled: {
    default: false,
    type: Boolean
  }
})

const selectedItem = computed((): SwitchItem => {
  return props?.items.find(val => val.value === props.modelValue) || { title: '', value: '' }
})

const onChange = (item: SwitchItem, { target }: { target: HTMLDivElement }): void => {
  if (selectedItem.value.value !== item.value) {
    if (item.disabled || props.disabled) {
      return
    }
    emit('update:modelValue', item.value)
    emit('change', item)
  }
}

const switcherItemClass = (item: SwitchItem): VzClass => {
  return  {
    'active': item.value === props.modelValue, 
    'disabled': props.disabled || item.disabled
  }
}
</script>